import PushNotificationTable from "@/app/app-shared/push-notification/push-notification-table";

export default function PushNotificationPage() {
  return (
    <div className="@container">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Push Notifications</h1>
      </div>
      <PushNotificationTable />
    </div>
  );
}
